export const getVariants = ({ products }) => {
  return products.reduce((collection, product) => {
    return collection.concat(product.variants);
  }, []);
};

export const variantWithSku = (sku, state) => {
  const variants = getVariants(state);
  const variant = variants.find(v => v.sku === sku);
  if (variant) {
    return variant;
  }
  reportMissingSku(sku, variants);
  return null;
};

export const reportMissingSku = (sku, variants) => {
  const error = new Error('Could not find variant for sku');

  if (typeof bugsnagClient !== 'undefined')
    bugsnagClient.notify(error, {
      severity: 'info',
      metaData: {
        sku,
        variants,
      },
    });
};
